// JavaScript Document

//splash
$(function () {
  const MIN_SPLASH_TIME = 1000;
  const HIDE_ANIM_DURATION = 600;
  const splashStart = performance.now();

  const splash = document.getElementById('splash');
  if (!splash) {
    window.dispatchEvent(new CustomEvent('splash:finished'));
    return;
  }

  function getActiveHeroVideo() {
    const videos = Array.from(document.querySelectorAll('.hero-video'));
    return videos.find(v => v.offsetParent !== null) || videos[0] || null;
  }

  const activeVideo = getActiveHeroVideo();
  let canPlayPromise = Promise.resolve();

  if (activeVideo) {
    canPlayPromise = new Promise(resolve => {
      if (activeVideo.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) return resolve();
      activeVideo.addEventListener('canplay', () => resolve(), { once: true });
    });
  }

  let splashHidden = false;

  async function completeSplashHide() {
    if (splashHidden) return;
    splashHidden = true;

    splash.style.display = 'none';

    // 他ファイルへ「splash終了」を通知
    window.dispatchEvent(new CustomEvent('splash:finished'));

    const video = getActiveHeroVideo();

    await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)));

    if (video) {
      try {
        await canPlayPromise.catch(() => {});
        await video.play();
      } catch (e) {
        video.muted = true;
        try { await video.play(); } catch {}
      }
    }
  }

  function hideSplash() {
    splash.classList.add('hide');

    splash.addEventListener('transitionend', () => {
      completeSplashHide();
    }, { once: true });

    setTimeout(() => {
      completeSplashHide();
    }, HIDE_ANIM_DURATION + 50);
  }

  const now = performance.now();
  const elapsed = now - splashStart;
  const wait = Math.max(0, MIN_SPLASH_TIME - elapsed);

  setTimeout(hideSplash, wait);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const v = getActiveHeroVideo();
      if (v) {
        const p = v.play();
        if (p && typeof p.then === 'function') {
          p.catch(() => {
            v.muted = true;
            v.play().catch(() => {});
          });
        }
      }
    }, 150);
  });
});
  //ハンバーガーメニュー
$(function () {
  // 共通：全メニューを閉じる
  function closeAllMenus() {
    // ハンバーガー
    $('#nav-input').prop('checked', false);
    $('#nav-open').removeClass('active');

    // ハンバーガー内アコーディオン（必要なら閉じる）
    $('.hamburger-sp__title, .hamburger-sp__sub-ttl').removeClass('js-rotate');
    $('.hamburger-sp__sub-menus, .hamburger-sp__sub-box').slideUp(0);

    // PCメガメニュー
    $('.header-itemlist__item').removeClass('--active');
    $('.drop-container').removeClass('drop-open');
  }

  // ハンバーガー開閉（既存ロジックを踏襲）
$('#nav-open').off('click.nav').on('click.nav', function (e) {
  e.preventDefault();    // 追加：labelのforによるinput自動クリックを止める
  e.stopPropagation();   // 外側閉じへの伝播抑止

  const $self = $(this);
  const willActive = !$self.hasClass('active');

  // 状態を一元管理
  $self.toggleClass('active', willActive);
  $('#nav-input').prop('checked', willActive);
});

  $('#nav-close').on('click', function () {
    closeAllMenus();
  });

  // ハンバーガー内の同一ページアンカーをクリックしたら閉じる（元の処理＋堅牢化）
  $('#nav-content a[href^="#"]').on('click', function () {
    closeAllMenus();
  });

  /* ハンバーガー内アコーディオン（元のまま） */
  $('.hamburger-sp__title').click(function () {
    $(this).toggleClass('js-rotate');
    $(this).next('.hamburger-sp__sub-menus').slideToggle();
  });

  $('.hamburger-sp__sub-ttl').click(function () {
    $(this).toggleClass('js-rotate');
    $(this).next('.hamburger-sp__sub-box').slideToggle();
  });


  // メガメニューの制御（元コードを踏襲しつつ、アンカークリックで閉じるを追加）
  // ドロップダウンメニューの開閉処理
  $('.hasDropdown').click(function (e) {
    e.preventDefault(); // 開閉専用のまま
    var parentMenu = $(this).closest('.header-itemlist__item');
    var isActive = parentMenu.hasClass('--active');

    // すべてのメニューを閉じる
    $('.header-itemlist__item').removeClass('--active');
    $('.drop-container').removeClass('drop-open');

    // クリックされたメニューのみ開く
    if (!isActive) {
      parentMenu.addClass('--active');
      parentMenu.find('.drop-container').addClass('drop-open');
    }
  });

  // noDropdown要素のクリック：閉じる（元の意図を維持）
  $('.noDropdown').click(function () {
    closeAllMenus();
  });

  // ドロップダウン内のリンクをクリックしたら閉じる（同一ページアンカー含む）
  $('.drop-container a').on('click', function () {
    closeAllMenus();
  });

  // メニュー外のクリックで閉じる（元の処理を closeAllMenus に置き換え）
$(document).off('click.navdoc').on('click.navdoc', function (e) {
  if (!$(e.target).closest('.header-itemlist__item, #nav-open, #nav-content').length) {
    closeAllMenus();
  }
});

  // ハッシュが変わったとき（同一ページアンカー遷移時）も閉じる
  $(window).on('hashchange', function () {
    closeAllMenus();
  });

$(function() { // DOMContentLoaded
  function toggleHeaderFixed() {
    var scroll = $(window).scrollTop() || 0;
    $('.pc-header').toggleClass('header-fixed', scroll >= 100);
    $('.sp-header').toggleClass('header-sp-fixed', scroll >= 60);
  }

  function init() {
    $(window).off('scroll.toggleHeaderFixed')
             .on('scroll.toggleHeaderFixed', toggleHeaderFixed);
    toggleHeaderFixed();
  }

  init();

  // bfcache復元対応
  $(window).on('pageshow', function() {
    init();
  });
});

 (function () {
  const visual = document.querySelector('.visual-pic');
  const header = document.querySelector('.pc-header');
  if (!visual || !header) return;

  const setInversion = (on) => header.classList.toggle('inversion', !!on);

  let thresholdY = 0; // .visual-pic の下端（ドキュメント座標）
  let topObstruction = 0; // 固定ヘッダー + adminbar の合計高さ

  function measure() {
    const rect = visual.getBoundingClientRect();
    const pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
    thresholdY = rect.bottom + pageY;

    const adminBar = document.getElementById('wpadminbar');
    const adminH = adminBar ? Math.max(adminBar.offsetHeight, adminBar.getBoundingClientRect().height) : 0;
    const headerH = header ? header.offsetHeight : 0;
    topObstruction = adminH + headerH;

    apply();
  }

  function apply() {
    const pageY = window.pageYOffset || document.documentElement.scrollTop || 0;
    // 実視界上端が .visual-pic の下端を超えたら inversion
    const passed = (pageY + topObstruction) >= thresholdY;
    setInversion(passed);
  }

  // 初期化
  window.addEventListener('load', () => {
    measure();
    apply();
  }, { once: true });

  window.addEventListener('resize', () => {
    // レイアウト変化時に再測定
    requestAnimationFrame(measure);
  }, { passive: true });

  window.addEventListener('scroll', () => {
    apply();
  }, { passive: true });
})();


if (window.innerWidth > 767) {
  $(window).on("scroll", function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 200) {
      //上から200pxスクロールしたら
      $("#page-top").removeClass("DownMove");
      $("#page-top").addClass("UpMove");
    } else {
      if ($("#page-top").hasClass("UpMove")) {
        $("#page-top").removeClass("UpMove");
        $("#page-top").addClass("DownMove");
      }
    }
  });
}



  //side-scroll
  new ScrollHint(".js-scrollable", {
    scrollHintIconAppendClass: "scroll-hint-icon-white",
    suggestiveShadow: true,
    i18n: {
      scrollable: "スクロールできます",
    },
  });

  //マウスドラッグスクロール
  jQuery.prototype.mousedragscrollable = function () {
    $(this).each(function () {
      let $target = $(this);
      $target.mousedown(function (event) {
        event.preventDefault();
        $target.data({
          down: true,
          move: false,
          x: event.clientX,
          y: event.clientY,
          scrollleft: $target.scrollLeft(),
          scrolltop: $target.scrollTop(),
        });
        // ドキュメントにmousemove, mouseupをバインド
        $(document).on('mousemove.mousedrag', function (event) {
          if ($target.data("down")) {
            event.preventDefault();
            let move_x = $target.data("x") - event.clientX;
            let move_y = $target.data("y") - event.clientY;
            if (move_x !== 0 || move_y !== 0) {
              $target.data("move", true);
            } else {
              return;
            }
            $target.scrollLeft($target.data("scrollleft") + move_x);
            $target.scrollTop($target.data("scrolltop") + move_y);
            return false;
          }
        }).on('mouseup.mousedrag', function () {
          $target.data("down", false);
          // イベントの解除
          $(document).off('.mousedrag');
          return false;
        });
        return false;
      });
      $target.click(function () {
        if ($target.data("move")) {
          $target.data("move", false);
          return false;
        }
      });
    });
  };
$(".side-scroll").mousedragscrollable();

});



// タブ
document.addEventListener("DOMContentLoaded", function () {
  const tabList = document.querySelectorAll(".tab-list-item");
  const tabContent = document.querySelectorAll(".tab-contents-item");

  for (let i = 0; i < tabList.length; i++) {
    tabList[i].addEventListener("click", tabSwitch);
  }

  function tabSwitch() {
    // すべてのタブからactiveを外す
    tabList.forEach(tab => tab.classList.remove("active"));
    // クリックしたタブにactiveをつける
    this.classList.add("active");

    // すべてのタブコンテンツからshowを外す
    tabContent.forEach(content => content.classList.remove("show"));
    // 該当するコンテンツにshowをつける
    const index = Array.prototype.indexOf.call(tabList, this);
    tabContent[index].classList.add("show");
  }
});

//アコーディオン

$(".accordion-content .ac-header").click(function () {
  $(this).next(".ac-inner").slideToggle();
  $(this).toggleClass("open");
});


//swiper
$(function () {
  const $mv = $('.main-visualInner');
  const swiper = new Swiper(".visualswiper", {
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 8000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    speed: 500,
    allowTouchMove: false,

    on: {
      init: function () { toggleTextColor(this); },
      slideChange: function () { toggleTextColor(this); },
    }
  });

  function toggleTextColor(sw) {
    // loop:true なので realIndex（0始まり）を使う
    $mv.toggleClass('is-slide-1', sw.realIndex === 0);
  }
});
$(function () {
  const $mv = $('.main-visualInner');
  const $mvBtns = $mv.find('.p-mainv-bnr .c-btn');
  const logoUse = document.getElementById('siteLogoUse');

  let isMvInView = false;

  const swiper = new Swiper('.visualswiper', {
    loop: true,
    effect: 'fade',
    autoplay: {
      delay: 8000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
    speed: 500,
    allowTouchMove: false,

    on: {
      init: function () {
        updateHeaderState(this);
      },
      slideChange: function () {
        updateHeaderState(this);
      },
    }
  });

  function updateHeaderState(sw) {
    if (!isMvInView) {
      resetHeaderState();
      return;
    }

    const isFirstSlide = sw.realIndex === 0;
    const logoPath = isFirstSlide
      ? './assets/img/symbol/sprite.svg#icon--logo_wh'
      : './assets/img/symbol/sprite.svg#icon--logo';

    $mv.toggleClass('is-slide-1', isFirstSlide);
    $mvBtns.toggleClass('c-btn--wh', isFirstSlide);

    if (logoUse) {
      logoUse.setAttribute('xlink:href', logoPath);
      logoUse.setAttribute('href', logoPath);
    }
  }

  function resetHeaderState() {
    $mv.removeClass('is-slide-1');
    $mvBtns.removeClass('c-btn--wh');

    if (logoUse) {
      const defaultLogoPath = './assets/img/symbol/sprite.svg#icon--logo';
      logoUse.setAttribute('xlink:href', defaultLogoPath);
      logoUse.setAttribute('href', defaultLogoPath);
    }
  }

  const target = document.querySelector('.main-visualInner');

  if (target) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isMvInView = entry.isIntersecting;

        if (isMvInView) {
          updateHeaderState(swiper);
        } else {
          resetHeaderState();
        }
      });
    }, {
      root: null,
      threshold: 0.1
    });

    observer.observe(target);
  }
});
//スクロールでロゴ縮小
$(function () {
  const $window = $(window);
  const $logo = $('#siteLogo');
  const logoEl = document.getElementById('siteLogo');
  const iconEl = document.querySelector('.c-head-icon');

  function updateLogoScale() {
    if (!logoEl || !iconEl) return;

    const scrollTop = $window.scrollTop();

    const currentWidth = iconEl.getBoundingClientRect().width;
    const minWidth = 180;
    const minScale = Math.min(1, minWidth / currentWidth);

    const shrinkScroll = 200;
    const progress = Math.min(scrollTop / shrinkScroll, 1);

    const scale = 1 - ((1 - minScale) * progress);

    $logo.css('transform', `scale(${scale})`);
  }

  updateLogoScale();
  $window.on('scroll resize', updateLogoScale);
});

//アンカー調整
$(function () {
       const additionalMargin = 20;

    // ヘッダーの高さ取得
    const getHeaderHeight = () => {
        if (window.innerWidth <= 1024) {
            return 60;
        }
        return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-pc_h')) || 135;
    };

    // フラグでhashchangeの二重発火を抑制
    let isManualScroll = false;

    // ページロード時のみアンカー調整
    $(window).on("load", function() {
        if (window.location.hash) {
            scrollToAnchor(window.location.hash);
        }
    });

    // スムーススクロール関数
    function scrollToAnchor(hash) {
        const targetElement = document.querySelector(hash);
        if (targetElement) {
            const rect = targetElement.getBoundingClientRect();
            const offsetTop = rect.top + window.pageYOffset - getHeaderHeight() - additionalMargin;
            window.scrollTo({
                top: offsetTop,
                behavior: "smooth"
            });
        }
    }

    // クリック時
    $('a[href^="#"]').on("click", function(e) {
        const href = $(this).attr("href");
        if (href.length > 1) {
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                e.preventDefault();
                isManualScroll = true;
                scrollToAnchor("#" + targetId);
                history.pushState(null, null, "#" + targetId);
                setTimeout(() => { isManualScroll = false; }, 100);
            }
        }
    });

    // hashchange時
    $(window).on("hashchange", function() {
        if (!isManualScroll) {
            scrollToAnchor(window.location.hash);
        }
    });
});

$(function () {
 // Intersection Observer で .reveal 要素を監視
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // 一度表示したら監視を外す（パフォーマンスと意図した挙動のため）
          obs.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // 10%入ったら表示
    });

    // 対象要素を登録
    document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

});


$(".sub-header-first").on("inview", function (event, isInView) {
  if (isInView) {
    //表示領域に入った時
    $(this).addClass("sub-header-first-anim"); //クラス名が付与
  }
});

$(".sub-header-second").on("inview", function (event, isInView) {
  if (isInView) {
    //表示領域に入った時
    $(this).addClass("sub-header-second-anim"); //クラス名が付与
  }
});

$(".sub-header").on("inview", function (event, isInView) {
  if (isInView) {
    //表示領域に入った時
    $(this).addClass("sub-header-anim"); //クラス名が付与
  }
});

//Note

 const notePosts = [
      {
        title: '採用課題を整理するための基本フレーム',
        url: 'https://note.com/brave_fairy316/n/n45277fc831f3',
        thumbnail: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
        date: '2026.05.01',
        tag: '採用戦略',
        excerpt: '採用がうまく進まないときは、まず母集団形成・選考・定着のどこにボトルネックがあるかを分けて考えることが重要です。'
      },
      {
        title: '応募数を増やすために見直したい導線設計',
        url: 'https://note.com/brave_fairy316',
        thumbnail: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80',
        date: '2026.04.21',
        tag: '母集団形成',
        excerpt: '求人票やLPだけではなく、問い合わせ導線やCTAの位置、フォームの項目数まで含めて見直すことで成果が変わることがあります。'
      },
      {
        title: '面接辞退を防ぐためのコミュニケーション設計',
        url: 'https://note.com/brave_fairy316',
        thumbnail: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80',
        date: '2026.04.10',
        tag: '面接改善',
        excerpt: '面接辞退は日程調整のスピードだけでなく、候補者への期待値調整や事前案内の質によっても大きく左右されます。'
      },
      {
        title: '採用広報で伝えるべきこと、伝えすぎないこと',
        url: 'https://note.com/brave_fairy316',
        thumbnail: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80',
        date: '2026.03.28',
        tag: '採用広報',
        excerpt: '情報量を増やせば応募が増えるとは限りません。候補者が知りたい情報を整理し、伝える順番を設計することが大切です。'
      },
      {
        title: '定着率改善のために入社前からできること',
        url: 'https://note.com/brave_fairy316',
        thumbnail: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
        date: '2026.03.12',
        tag: '定着支援',
        excerpt: '内定後フォローからオンボーディングまでの設計を見直すことで、入社後のギャップや早期離職のリスクを下げられます。'
      }
    ];

    const slider = document.getElementById('noteSlider');

    function createNoteCard(post) {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';

      slide.innerHTML = `
        <a href="${post.url}" class="note-card" target="_blank" rel="noopener noreferrer">
          <div class="note-card__thumb">
            <img src="${post.thumbnail}" alt="${post.title}">
          </div>
          <div class="note-card__body">
            <div class="note-card__meta">
              <!--<span class="note-card__tag">${post.tag}</span>-->
              <time datetime="${post.date}">${post.date}</time>
            </div>
            <h3 class="note-card__title">${post.title}</h3>
            <p class="note-card__excerpt">${post.excerpt}</p>
            <div class="note-card__more">MORE..</div>
          </div>
        </a>
      `;

      return slide;
    }

    notePosts.forEach((post) => {
      slider.appendChild(createNoteCard(post));
    });

    new Swiper('.js-note-swiper', {
      slidesPerView: 1.15,
      spaceBetween: 16,
      speed: 700,
      watchOverflow: true,
      navigation: {
        nextEl: '.js-note-next',
        prevEl: '.js-note-prev',
      },
      // pagination: {
      //   el: '.js-note-pagination',
      //   clickable: true,
      // },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1281: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });

    //ハンバーガー
$(function () {
      const menuButton = document.getElementById('menuButton');
    const menuPanel = document.getElementById('menuPanel');
    const siteLogo = document.getElementById('siteLogo');

    menuButton.addEventListener('click', () => {
      const isOpen = menuPanel.classList.toggle('open');
      menuButton.classList.toggle('active', isOpen);
      siteLogo.classList.toggle('menu-open', isOpen);
      menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      menuButton.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    });
    });


//斜め線
$(function () {
(() => {
      const path = document.getElementById('bg-line-path');
      const light = document.getElementById('bg-line-light');

      if (!path || !light) return;

      const DURATION = 1800;
      const INTERVAL = 6000;

      let rafId = null;
      let running = false;

      function placeLightAt(progress) {
        const totalLength = path.getTotalLength();
        const point = path.getPointAtLength(totalLength * progress);

        const svg = path.ownerSVGElement;
        const svgRect = svg.getBoundingClientRect();
        const viewBox = svg.viewBox.baseVal;

        const scaleX = svgRect.width / viewBox.width;
        const scaleY = svgRect.height / viewBox.height;

        const x = (point.x - viewBox.x) * scaleX;
        const y = (point.y - viewBox.y) * scaleY;

        light.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      }

      function easeInOutSine(t) {
  return -(Math.cos(Math.PI * t) - 1) / 2;
}

function runLight() {
  if (running) return;
  running = true;

  const start = performance.now();
  light.style.opacity = '1';

  function tick(now) {
    const elapsed = now - start;
    const raw = Math.min(elapsed / DURATION, 1);
    const progress = easeInOutSine(raw);

    placeLightAt(progress);

    const fade = raw < 0.1
      ? raw / 0.1
      : raw > 0.82
        ? (1 - raw) / 0.18
        : 1;

    light.style.opacity = String(Math.max(0, Math.min(fade, 1)));

    if (raw < 1) {
      rafId = requestAnimationFrame(tick);
    } else {
      light.style.opacity = '0';
      running = false;
    }
  }

  rafId = requestAnimationFrame(tick);
}

      function resetLightToStart() {
        placeLightAt(0);
        light.style.opacity = '0';
      }

      resetLightToStart();
      runLight();
      const timer = setInterval(runLight, INTERVAL);

      window.addEventListener('resize', resetLightToStart);

      window.addEventListener('beforeunload', () => {
        clearInterval(timer);
        if (rafId) cancelAnimationFrame(rafId);
      });
    })();
    });

//lenis
// 初期化
const lenis = new Lenis();

// Lenisのスクロールイベントに合わせて全てのScrollTriggerインスタンスをアップデート
lenis.on('scroll', ScrollTrigger.update);

// LenisのrafメソッドをGSAP tickerに追加 
gsap.ticker.add((time) => {
  lenis.raf(time * 1000); // tickerのタイムスタンプの単位は秒なので、ミリ秒に変換
});

// レンダリング時にラグが発生した際のアニメーション調整機能を無効化
gsap.ticker.lagSmoothing(0);
